var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'lab-page',
    !_vm.isLoading &&
      _vm.isVulnerabilityColl &&
      ("lab-page__vulnerabilities-bg--vulnerabilities-bg-" + _vm.vulnerabilityBg) ]},[(_vm.isLoading)?_c('ActionLoader',{staticClass:"lab-page__loader",attrs:{"name":"ball-clip-rotate","size":2}}):[(_vm.isSkillDive)?_c('SkillDiveLab',{attrs:{"parentContext":_vm.parentContext},on:{"start-issue":_vm.startIssue}}):_c('LabModal',{attrs:{"parentContext":_vm.parentContext},on:{"prev-route":_vm.goToPrevRoute,"start-issue":_vm.startIssue}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }